export default __webpack_public_path__ + "static/media/time.7404af9b.svg";